/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47825Req {
  
  /** 汇报编号 */
  reportNo?: string;
  /** 项目编号 */
  projectNo?: string;
  /** 汇报日期,yyyy-MM-dd */
  reportDate?: any;
  /** 内容 */
  content?: string;
  /** 项目进度,double值，61.23 */
  projectProgressDou?: number;
};



export type API47825Res = {};


// 47825 编辑项目汇报

export interface IUsePostAPI47825Return {
  /** 编辑项目汇报: 接口请求状态 */
  isAPI47825Loading: boolean;
  /** 编辑项目汇报: 接口请求返回数据 */
  dataAPI47825: API47825Res;
  /**  编辑项目汇报: 接口数据请求方法 */
  fetchAPI47825Data:  (inputs: API47825Req, config?: YWRequestConfig) => Promise<API47825Res>;
  /** 编辑项目汇报: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47825 = ():IUsePostAPI47825Return => {
  let isMount = true;
  const [isAPI47825Loading, setIsAPI47825Loading] = useState(false);
  const [dataAPI47825, setDataAPI47825] = useState<API47825Res>({} as API47825Res);
  const requestUrl = `${basePath}/corp-admin/project/report/edit`;

  const fetchAPI47825Data = async (inputs: API47825Req, config?: YWRequestConfig): Promise<API47825Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47825Req>) || {}) as API47825Req;
    
  
    if ( isMount ) {
      setIsAPI47825Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47825Res>(`${basePath}/corp-admin/project/report/edit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47825(res || {} as API47825Res);
        setIsAPI47825Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47825Loading(false);
      }
      return false as unknown as API47825Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47825Loading,
    dataAPI47825,
    fetchAPI47825Data,
    requestUrl,
  }
}

